import axios from 'axios';

const baseURL = process.env.VUE_APP_ORIGIN || window.location.origin;

const axiosAPI = axios.create({
  baseURL: `${baseURL}/api`,
});

export default axiosAPI;
